// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper to allow scrolling on small screens */
.jobsKinder-table-wrapper {
  overflow-x: auto;
  margin-top: 1rem;
  margin-bottom: 1.5rem; /* space below table */
}

/* Styled table matching the CI */
.jobsKinder-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--hellgruen);
  border-radius: 12px;
  overflow: hidden;
}

.jobsKinder-table thead th {
  background-color: var(--dunkelgruen);
  color: var(--blassgruen);
  font-size: calc(1rem + 2px); /* enlarge header text */
}


.jobsKinder-table th,
.jobsKinder-table td {
  padding: 0.75rem;
  text-align: center;
  border: none;
  font-family: 'Circular', sans-serif;
  font-weight: normal;
}

.jobsKinder-table th {
  font-family: 'Staatliches', sans-serif;
}

.jobsKinder-table td {
  font-family: 'Circular', sans-serif;
  font-size: calc(1rem - 2px); /* shrink body text */
  color: var(--dunkelgruen);
}

/* Bold body text */
.jobsKinder-table tbody td {
  font-weight: normal;
}

/* Left-align first column header and cells */
.jobsKinder-table th:first-child,
.jobsKinder-table td:first-child {
  text-align: left;
}

.jobsKinder-table th {
  font-family: 'Staatliches', sans-serif;
}

.jobsKinder-table td {
  font-family: 'Circular', sans-serif;
}

.jobsKinder-table tbody tr:nth-child(even) {
  background-color: var(--blassgruen);
}

.jobs-count-cell {
  position: relative;
}

.warning-icon {
  color: var(--blutorange);
  font-size: 1rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(1rem, -50%);
}

.warning-legend {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--blutorange);
  font-family: 'Circular', sans-serif;
}

.warning-legend .material-symbols-outlined {
  color: var(--blutorange);
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/jobskinder/JobsKinder.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B,EAAE,wBAAwB;AACvD;;;AAGA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B,EAAE,qBAAqB;EAClD,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Wrapper to allow scrolling on small screens */\n.jobsKinder-table-wrapper {\n  overflow-x: auto;\n  margin-top: 1rem;\n  margin-bottom: 1.5rem; /* space below table */\n}\n\n/* Styled table matching the CI */\n.jobsKinder-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.jobsKinder-table thead th {\n  background-color: var(--dunkelgruen);\n  color: var(--blassgruen);\n  font-size: calc(1rem + 2px); /* enlarge header text */\n}\n\n\n.jobsKinder-table th,\n.jobsKinder-table td {\n  padding: 0.75rem;\n  text-align: center;\n  border: none;\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n}\n\n.jobsKinder-table th {\n  font-family: 'Staatliches', sans-serif;\n}\n\n.jobsKinder-table td {\n  font-family: 'Circular', sans-serif;\n  font-size: calc(1rem - 2px); /* shrink body text */\n  color: var(--dunkelgruen);\n}\n\n/* Bold body text */\n.jobsKinder-table tbody td {\n  font-weight: normal;\n}\n\n/* Left-align first column header and cells */\n.jobsKinder-table th:first-child,\n.jobsKinder-table td:first-child {\n  text-align: left;\n}\n\n.jobsKinder-table th {\n  font-family: 'Staatliches', sans-serif;\n}\n\n.jobsKinder-table td {\n  font-family: 'Circular', sans-serif;\n}\n\n.jobsKinder-table tbody tr:nth-child(even) {\n  background-color: var(--blassgruen);\n}\n\n.jobs-count-cell {\n  position: relative;\n}\n\n.warning-icon {\n  color: var(--blutorange);\n  font-size: 1rem;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(1rem, -50%);\n}\n\n.warning-legend {\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--blutorange);\n  font-family: 'Circular', sans-serif;\n}\n\n.warning-legend .material-symbols-outlined {\n  color: var(--blutorange);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
